import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=320a455b&scoped=true"
import script from "./Reserve.vue?vue&type=script&lang=js"
export * from "./Reserve.vue?vue&type=script&lang=js"
import style0 from "./Reserve.vue?vue&type=style&index=0&id=320a455b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a455b",
  null
  
)

export default component.exports